import * as React from "react";
import {
  IconCamera,
  IconDashboard,
  IconDatabase,
  IconFileAi,
  IconFileDescription,
  IconFileWord,
  IconHelp,
  IconInnerShadowTop,
  IconReport,
  IconSearch,
  IconSettings,
  IconUsers,
  IconBuilding,
  IconTransfer,
  IconReceipt,
  IconFileInvoice,
  IconCreditCard,
  IconCash,
  IconShield,
  IconBook,
} from "@tabler/icons-react";

import { NavDocuments } from "@/components/nav-documents";
import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useHasPermission } from "@/features/auth/hooks/use-has-permission";
import { useMemo } from "react";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const ableToViewAccountReceivable = useHasPermission(
    "account_receivable:read",
  );
  const ableToViewAccountPayable = useHasPermission("account_payable:read");
  const ableToViewInvoice = useHasPermission("invoice:read");
  const ableToViewBill = useHasPermission("bill:read");
  const ableToViewTransaction = useHasPermission("transaction:read");

  const ableToViewClientCompany = useHasPermission("client_company:read");
  const ableToViewVendor = useHasPermission("vendor:read");
  const ableToViewPaymentMethod = useHasPermission("payment_method:read");

  const ableToViewUser = useHasPermission("user:read");
  const ableToViewSettings = useHasPermission("settings:read");
  const ableToViewRoles = useHasPermission("role_permission:read");
  const ableToViewJournal = useHasPermission("journal:read");
  const ableToViewAccount = useHasPermission("account:read");

  const data = useMemo(() => {
    return {
      user: {
        name: "AGT DEMO",
        email: "hi@agt.com",
        avatar: "/avatars/shadcn.jpg",
      },
      navMain: [
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: IconDashboard,
        },
        // {
        //   title: "Lifecycle",
        //   url: "#",
        //   icon: IconListDetails,
        // },
        // {
        //   title: "Analytics",
        //   url: "#",
        //   icon: IconChartBar,
        // },
        // {
        //   title: "Projects",
        //   url: "#",
        //   icon: IconFolder,
        // },
        // {
        //   title: "Team",
        //   url: "#",
        //   icon: IconUsers,
        // },
      ],
      navClouds: [
        {
          title: "Capture",
          icon: IconCamera,
          isActive: true,
          url: "#",
          items: [
            {
              title: "Active Proposals",
              url: "#",
            },
            {
              title: "Archived",
              url: "#",
            },
          ],
        },
        {
          title: "Proposal",
          icon: IconFileDescription,
          url: "#",
          items: [
            {
              title: "Active Proposals",
              url: "#",
            },
            {
              title: "Archived",
              url: "#",
            },
          ],
        },
        {
          title: "Prompts",
          icon: IconFileAi,
          url: "#",
          items: [
            {
              title: "Active Proposals",
              url: "#",
            },
            {
              title: "Archived",
              url: "#",
            },
          ],
        },
      ],
      navSecondary: [
        {
          title: "Settings",
          url: "#",
          icon: IconSettings,
        },
        {
          title: "Get Help",
          url: "#",
          icon: IconHelp,
        },
        {
          title: "Search",
          url: "#",
          icon: IconSearch,
        },
      ],
      documents: [
        {
          name: "Data Library",
          url: "#",
          icon: IconDatabase,
        },
        {
          name: "Reports",
          url: "#",
          icon: IconReport,
        },
        {
          name: "Word Assistant",
          url: "#",
          icon: IconFileWord,
        },
      ],
      financial: [
        ...(ableToViewTransaction
          ? [
              {
                name: "Transaksi",
                url: "/financial/transaction",
                icon: IconTransfer,
              },
            ]
          : []),
        ...(ableToViewBill
          ? [
              {
                name: "Kwitansi (Bills)",
                url: "/financial/bill",
                icon: IconReceipt,
              },
            ]
          : []),
        ...(ableToViewAccountReceivable
          ? [
              {
                name: "Account Receivable",
                url: "/financial/account-receivable",
                icon: IconReceipt,
              },
            ]
          : []),
        ...(ableToViewAccountPayable
          ? [
              {
                name: "Account Payable",
                url: "/financial/account-payable",
                icon: IconReceipt,
              },
            ]
          : []),
        ...(ableToViewInvoice
          ? [
              {
                name: "Invoice",
                url: "/financial/invoice",
                icon: IconFileInvoice,
              },
            ]
          : []),
        // TODO: add petty cash permission
        {
          name: "Petty Cash",
          url: "/financial/petty-cash",
          icon: IconCash,
        },
        ...(ableToViewJournal
          ? [
              {
                name: "Journal",
                url: "/financial/journal",
                icon: IconBook,
              },
            ]
          : []),
      ],
      masterData: [
        // {
        //   name: "Customer",
        //   url: "/master-data/customer",
        //   icon: IconUsers,
        // },
        ...(ableToViewVendor
          ? [
              {
                name: "Vendor",
                url: "/master-data/vendor",
                icon: IconBuilding,
              },
            ]
          : []),
        ...(ableToViewClientCompany
          ? [
              {
                name: "Perusahaan",
                url: "/master-data/client",
                icon: IconBuilding,
              },
            ]
          : []),

        ...(ableToViewUser
          ? [
              {
                name: "User",
                url: "/master-data/user",
                icon: IconUsers,
              },
            ]
          : []),
        ...(ableToViewAccount
          ? [
              {
                name: "Chart of Accounts",
                url: "/master-data/account",
                icon: IconBook,
              },
            ]
          : []),
      ],
      settings: [
        ...(ableToViewSettings
          ? [
              {
                name: "General Settings",
                url: "/settings/general",
                icon: IconSettings,
              },
            ]
          : []),
        ...(ableToViewPaymentMethod
          ? [
              {
                name: "Metode Pembayaran",
                url: "/settings/payment-methods",
                icon: IconCreditCard,
              },
            ]
          : []),
        ...(ableToViewRoles
          ? [
              {
                name: "Role Management",
                url: "/settings/roles",
                icon: IconShield,
              },
            ]
          : []),
      ],
    };
  }, [
    ableToViewUser,
    ableToViewAccountPayable,
    ableToViewAccountReceivable,
    ableToViewBill,
    ableToViewInvoice,
    ableToViewTransaction,
    ableToViewClientCompany,
    ableToViewVendor,
    ableToViewPaymentMethod,
    ableToViewSettings,
    ableToViewRoles,
    ableToViewJournal,
    ableToViewAccount,
  ]);

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="#">
                <IconInnerShadowTop className="!size-5" />
                <span className="text-base font-semibold">
                  Travallis Wisata Indonesia
                </span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {(ableToViewTransaction ||
          ableToViewBill ||
          ableToViewAccountReceivable ||
          ableToViewAccountPayable ||
          ableToViewInvoice) && (
          <NavDocuments title="Financial" items={data.financial} />
        )}

        {(ableToViewVendor ||
          ableToViewClientCompany ||
          ableToViewUser ||
          ableToViewAccount) && (
          <NavDocuments title="Master Data" items={data.masterData} />
        )}

        {(ableToViewPaymentMethod || ableToViewSettings) && (
          <NavDocuments title="Settings" items={data.settings} />
        )}
        {/* <NavSecondary items={data.navSecondary} className="mt-auto" /> */}
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
